<template>
  <div id="p-cesiumContainer" style="width: 100%; height: 100%;background-color: #171e21b3"></div>
  <!-- 车辆标签容器 -->
  <div v-for="(label, carId) in carLabels" :key="carId" v-show="label.show" :style="label.style"
    :class="['car-label', { 'car-label-selected': selectedCarId === carId }]">
    <div class="car-label-content">{{ label.text }}</div>
  </div>
  <!--  &lt;!&ndash; 选中车辆的标记 &ndash;&gt;-->
  <!--  <div v-if="selectedCarPosition" class="selected-car-marker" :style="selectedMarkerStyle">-->
  <!--    <div class="marker-pulse"></div>-->
  <!--    <div class="marker-center"></div>-->
  <!--  </div>-->
</template>

<script>
import * as Cesium from 'cesium'
Cesium.Ion.defaultAccessToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI1ZDk0ZWM3Mi0wNjliLTRkNjAtYjBkMS0zZWY0OGIxNDIxYzkiLCJpZCI6MjQ0OTEsInNjb3BlcyI6WyJhc3IiLCJnYyJdLCJpYXQiOjE1ODUyOTEwOTd9.11P_WP5Lv-fcvJ4KZFp2onou7_-5fTUAaGavg-T_Aho"
export default {
  emits: ['car-click'],
  data() {
    return {
      selectedCar: null, // 当前选中的车辆实体
      selectedCarId: null, // 当前选中的车辆ID
      selectedCarPosition: null, // 当前选中车辆的位置
      selectedMarkerStyle: {}, // 选中标记的样式
      carEntityMap: {}, // car.id => entity 映射
      clickHandler: null, // 点击事件处理器
      carLabels: {}, // 车辆标签信息
      carsData: [
      {
            id: '1号巡检车',
            type:'car',
            image: 'https://shchwhale1.oss-cn-hangzhou.aliyuncs.com/car1.glb',
            videoUrl: '/zssqf.mp4',
            coordinates: [
              {timestamp: Date.now(), location: [121.602408, 30.024817]},
              {timestamp: Date.now() + 5000, location: [121.602577, 30.024965]},
              {timestamp: Date.now() + 15000, location: [121.602719, 30.024968]},
              {timestamp: Date.now() + 20000, location: [121.602909, 30.024951]},
              {timestamp: Date.now() + 25000, location: [121.60308, 30.024927]},
              {timestamp: Date.now() + 30000, location: [121.603045, 30.024717]}
            ]
          },
          {
            id: '2号巡检车',
            type:'car',
            image: 'https://shchwhale1.oss-cn-hangzhou.aliyuncs.com/car1.glb',
            videoUrl: '/zssqf.mp4',
            coordinates: [
              {timestamp: Date.now() + 22500, location: [121.601863, 30.025043]},
              {timestamp: Date.now() + 25000, location: [121.602095, 30.025061]},
              {timestamp: Date.now() + 30000, location: [121.602151, 30.024852]},
              {timestamp: Date.now() + 35000, location: [121.602365, 30.024796]},
              {timestamp: Date.now() + 40000, location: [121.602532, 30.024984]},
              {timestamp: Date.now() + 45000, location: [121.602565, 30.025291]}
            ]
          },
          {
            id: '1号人员巡检',
            type:'person',
            image: 'https://shchwhale1.oss-cn-hangzhou.aliyuncs.com/person1.glb',
            videoUrl: '/zssqf.mp4',
            coordinates: [
              {timestamp: Date.now(), location: [121.602473, 30.025015]},
              {timestamp: Date.now() + 25000, location: [121.602423, 30.025015]},
              {timestamp: Date.now() + 30000, location: [121.602345, 30.025037]},
              {timestamp: Date.now() + 35000, location: [121.602231, 30.025052]},
              {timestamp: Date.now() + 40000, location: [121.602115, 30.025061]},
              {timestamp: Date.now() + 45000, location: [121.601916, 30.025076]}
            ]
          }
      ]
    }
  },

  async mounted() {
    const viewer = this.viewer = new Cesium.Viewer('p-cesiumContainer', {
      animation: true,
      timeline: true,
      baseLayerPicker: false,
      homeButton: false,
      sceneMode: Cesium.SceneMode.SCENE3D,
      terrainProvider: await Cesium.createWorldTerrainAsync({
        requestWaterMask: true,
        requestVertexNormals: true
      }),
      creditContainer: undefined,
      fullscreenButton: false,
      contextOptions: {
        webgl: {
          alpha: true  // 启用透明度
        }
      }
    })

    viewer.imageryLayers.remove(viewer.imageryLayers.get(0))
    viewer.scene.globe.depthTestAgainstTerrain = true
    // 移除版权信息
    viewer._cesiumWidget._creditContainer.style.display = "none"

    // 移除默认的baseLayer（可选）
    viewer.imageryLayers.remove(viewer.imageryLayers.get(0))
    viewer.scene.globe.show = false
    viewer.scene.skyBox.show = false;
    viewer.scene.skyAtmosphere.show = false;
    viewer.scene.backgroundColor = Cesium.Color.TRANSPARENT;

    const tileset = await Cesium.Cesium3DTileset.fromUrl('/mapdata/3dtiles/ymf/tileset.json')
    viewer.scene.primitives.add(tileset)

    const boundingSphere = tileset.boundingSphere
    const cartographic = Cesium.Cartographic.fromCartesian(boundingSphere.center)
    const surface = Cesium.Cartesian3.fromRadians(cartographic.longitude, cartographic.latitude, 0.0)
    const offset = Cesium.Cartesian3.fromRadians(cartographic.longitude, cartographic.latitude, 0.0)
    const translation = Cesium.Cartesian3.subtract(offset, surface, new Cesium.Cartesian3())
    tileset.modelMatrix = Cesium.Matrix4.fromTranslation(translation)

    viewer.zoomTo(tileset)

    this.drawCarsWithPaths(this.carsData)

    viewer.clock.onTick.addEventListener(() => {
      this.updateModelScales()
    })

  },

  methods: {
    getViewer() {
      return this.viewer;
    },

    updateModelScales() {
      const viewer = this.viewer;
      if (!viewer) return;

      const currentTime = viewer.clock.currentTime;

      // 遍历所有车辆实体
      Object.entries(this.carEntityMap).forEach(([carId, entity]) => {
        // 检查车辆在当前时间点是否可见（是否在巡检中）
        const isAvailable = entity.isAvailable(currentTime);

        // 获取车辆当前位置
        const position = isAvailable ? entity.position.getValue(currentTime) : null;

        if (position) {
          // 车辆在巡检中，显示标签
          const canvasPosition = Cesium.SceneTransforms.worldToWindowCoordinates(viewer.scene, position);
          if (canvasPosition) {
            // 更新或创建标签
            this.updateCarLabel(carId, carId, true, {
              top: `${canvasPosition.y - 50}px`,
              left: `${canvasPosition.x - 50}px`
            });

            // 如果是选中的车辆，更新选中标记的位置
            if (this.selectedCarId === carId) {
              this.selectedCarPosition = position;
              this.selectedMarkerStyle = {
                top: `${canvasPosition.y}px`,
                left: `${canvasPosition.x}px`
              };
            }
          }
        } else {
          // 车辆不在巡检中，隐藏标签
          if (this.carLabels[carId]) {
            this.carLabels[carId].show = false;
          }

          // 如果是选中的车辆且不可见，隐藏选中标记
          if (this.selectedCarId === carId) {
            this.selectedCarPosition = null;
          }
        }
      });
    },

    // 清除所有车辆实体
    clearCars() {
      const viewer = this.viewer;
      if (!viewer) return;

      // 存储当前时钟状态
      const currentClockState = {
        startTime: viewer.clock.startTime.clone(),
        stopTime: viewer.clock.stopTime.clone(),
        currentTime: viewer.clock.currentTime.clone(),
        multiplier: viewer.clock.multiplier
      };

      // 清除所有实体（包括车辆和轨迹线）
      viewer.entities.removeAll();

      // 重置映射和状态
      this.carEntityMap = {};
      this.selectedCar = null;
      this.selectedCarId = null;
      this.selectedCarPosition = null;

      // 清除车辆标签
      this.carLabels = {};

      // 重置数据
      this.carsData = [];

      return currentClockState; // 返回时钟状态，以便在需要时恢复
    },

    // 聚焦到特定车辆
    focusOnCar(carId) {
      const entity = this.carEntityMap[carId];
      if (entity && this.viewer) {
        // 设置为选中状态
        this.selectedCar = entity;
        this.selectedCarId = carId;

        // 立即更新选中车辆的位置和标记
        const currentTime = this.viewer.clock.currentTime;
        const position = entity.position.getValue(currentTime);
        if (position) {
          const canvasPosition = Cesium.SceneTransforms.worldToWindowCoordinates(this.viewer.scene, position);
          if (canvasPosition) {
            this.selectedCarPosition = position;
            this.selectedMarkerStyle = {
              top: `${canvasPosition.y}px`,
              left: `${canvasPosition.x}px`
            };
          }
        }

        // 飞行到车辆位置
        this.viewer.flyTo(entity, {
          duration: 1.5,
          offset: new Cesium.HeadingPitchRange(0, -Math.PI / 4, 150)
        });
      }
    },

    drawCarsWithPaths(cars) {
      const viewer = this.viewer;
      if (!viewer) return;

      // 保存车辆数据
      this.carsData = [...cars];

      let globalStart = null;
      let globalEnd = null;

      cars.forEach(car => {
        // 确保车辆有image属性
        const carImage = car.image;

        const times = car.coordinates.map(c => Cesium.JulianDate.fromDate(new Date(c.timestamp)));
        const start = times[0];
        const end = times[times.length - 1];

        if (!globalStart || Cesium.JulianDate.lessThan(start, globalStart)) globalStart = start;
        if (!globalEnd || Cesium.JulianDate.greaterThan(end, globalEnd)) globalEnd = end;

        const positionProp = new Cesium.SampledPositionProperty();
        car.coordinates.forEach(coord => {
          const time = Cesium.JulianDate.fromDate(new Date(coord.timestamp));
          const pos = Cesium.Cartesian3.fromDegrees(coord.location[0], coord.location[1], 28.5);
          positionProp.addSample(time, pos);
        });


        const carEntity = viewer.entities.add({
          id: car.id,
          availability: new Cesium.TimeIntervalCollection([
            new Cesium.TimeInterval({ start, stop: end })
          ]),
          position: positionProp,
          model: {
            uri: carImage,
            scale: car.type === 'car' ? 1 : 0.01
          },
          orientation: new Cesium.VelocityOrientationProperty(positionProp)
        });


        this.carEntityMap[car.id] = carEntity;

        // 初始化车辆标签（默认隐藏）
        this.updateCarLabel(car.id, car.id, false, {});

        const dynamicPositions = [];
        let lastTime = null;
        const positionCallback = new Cesium.CallbackProperty(() => {
          const currentTime = viewer.clock.currentTime;
          if (lastTime && Cesium.JulianDate.lessThan(currentTime, lastTime)) {
            dynamicPositions.length = 0;
          }
          lastTime = Cesium.JulianDate.clone(currentTime);

          const pos = positionProp.getValue(currentTime);
          if (pos) {
            const last = dynamicPositions[dynamicPositions.length - 1];
            if (!last || !Cesium.Cartesian3.equals(pos, last)) {
              dynamicPositions.push(pos);
            }
          }
          return dynamicPositions;
        }, false);
        viewer.entities.add({
          name: '巡检路线',
          polyline: {
            positions: car.coordinates.map(coord =>
              Cesium.Cartesian3.fromDegrees(coord.location[0], coord.location[1], 28.5)
            ),
            width: 3,
            material: Cesium.Color.fromRandom({ alpha: 1.0 }),
          }
        });

        // viewer.entities.add({
        //   polyline: {
        //     positions: positionCallback,
        //     width: 5,
        //     material: Cesium.Color.LIGHTGREEN
        //   }
        // });
      });

      // 移除旧的事件处理器
      if (this.clickHandler) {
        this.clickHandler.destroy();
        this.clickHandler = null;
      }

      // 添加新的点击事件处理器
      const carIds = cars.map(car => car.id);
      this.clickHandler = viewer.screenSpaceEventHandler.setInputAction((click) => {
        const picked = viewer.scene.pick(click.position);
        if (Cesium.defined(picked) && picked.id && carIds.indexOf(picked.id.id) > -1) {
          this.selectedCar = this.carEntityMap[picked.id.id];
          this.selectedCarId = picked.id.id;

          // 立即更新选中车辆的位置和标记
          const currentTime = viewer.clock.currentTime;
          const position = this.selectedCar.position.getValue(currentTime);
          if (position) {
            const canvasPosition = Cesium.SceneTransforms.worldToWindowCoordinates(viewer.scene, position);
            if (canvasPosition) {
              this.selectedCarPosition = position;
              this.selectedMarkerStyle = {
                top: `${canvasPosition.y}px`,
                left: `${canvasPosition.x}px`
              };
            }
          }

          // 查找对应的车辆数据
          const carData = this.carsData.find(car => car.id === picked.id.id);
          if (carData) {
            // 触发事件，通知父组件显示视频
            this.$emit('car-click', {
              id: carData.id,
              videoUrl: carData.videoUrl
            });
          }
        }
      }, Cesium.ScreenSpaceEventType.LEFT_CLICK);

      // 设置时钟
      if (globalStart && globalEnd) {
        viewer.clock.startTime = globalStart.clone();
        viewer.clock.stopTime = globalEnd.clone();
        viewer.clock.currentTime = globalStart.clone();
        viewer.clock.clockRange = Cesium.ClockRange.LOOP_STOP;
        viewer.clock.multiplier = 1;
        viewer.timeline.zoomTo(globalStart, globalEnd);
      }
    },

    closePopup() {
      this.selectedCar = null;
      this.selectedCarId = null;
      this.selectedCarPosition = null;
    },

    updateCarLabel(carId, text, show, style) {
      this.carLabels[carId] = { text, show, style };
    }
  },

  unmounted() {
    // 清理事件处理器
    if (this.clickHandler) {
      this.clickHandler.destroy();
      this.clickHandler = null;
    }

    // 销毁Cesium viewer
    if (this.viewer) {
      this.viewer.destroy();
      this.viewer = null;
    }
  }
}
</script>

<style lang="less" scoped>
.car-label {
  position: absolute;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  padding: 5px;
  border-radius: 2px;
  pointer-events: none;
  transition: all 0.3s ease;
}

.car-label-selected {
  background: rgba(0, 123, 255, 0.8);
  color: white;
  font-weight: bold;
  transform: scale(1.1);
  z-index: 1001;
}

.car-label-content {
  white-space: nowrap;
}

.selected-car-marker {
  position: absolute;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.8);
  border: 2px solid #007bff;
  transform: translate(-50%, -50%);
  pointer-events: none;
}

.marker-pulse {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.2);
  animation: pulse 1.5s infinite;
}

.marker-center {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: #007bff;
}

@keyframes pulse {
  0% {
    transform: scale(0.5);
    opacity: 0.5;
  }

  50% {
    transform: scale(1);
    opacity: 1;
  }

  100% {
    transform: scale(1.5);
    opacity: 0;
  }
}
</style>
